import { KeycloakRealm } from '../types'
import environment from '../../../config'
import instances from './instances'
import {
  handleOtherTabsLogin,
  notifyOtherTabsAboutLogin,
  renewSession,
  updateToken,
  updateIdTokenInStorage,
} from './sessionService'
import { getRealmFromStorage, setRealmInStorage } from './storageService'

const shouldEmitLogs: boolean = environment.debugEnabled

const loadRealm = async (realm: KeycloakRealm): Promise<void> => {
  try {
    await instances.options[realm].init({
      onLoad: 'check-sso',
      flow: 'standard',
      enableLogging: shouldEmitLogs,
      silentCheckSsoFallback: true,
      silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
      checkLoginIframe: false, 
    })

    if (shouldEmitLogs) console.log(`[KEYCLOAK] Instance of realm '${realm}' loaded with success.`)
  } catch (err) {
    console.error(`[KEYCLOAK] Error while trying to load '${realm}' realm instance.`, err)
  }
}

const setupActiveInstance = (currentRealm: KeycloakRealm): void => {
  instances.active = instances.options[currentRealm]

  instances.active.onAuthSuccess = notifyOtherTabsAboutLogin
  instances.active.onAuthLogout = renewSession
  instances.active.onTokenExpired = updateToken

  if (shouldEmitLogs) console.log(`[KEYCLOAK] Using realm '${currentRealm}' for auth context.`)
}

const validateLoginRedirection = (): void => {
  const urlParams = new URLSearchParams(window.location.search)

  const realm = urlParams.get('sso')

  const isLoginRedirect: boolean =
    window.location.pathname === '/' &&
    realm !== null &&
    Object.keys(instances.options).includes(realm)

  if (isLoginRedirect) {
    setRealmInStorage(realm as KeycloakRealm)
    window.history.pushState(null, '', window.location.origin)
  }
}

const initialize = async (): Promise<void> => {
  validateLoginRedirection()

  const currentRealm: KeycloakRealm = getRealmFromStorage()

  setupActiveInstance(currentRealm)

  handleOtherTabsLogin()

  await loadRealm(currentRealm)

  updateIdTokenInStorage()
}

export default initialize
